import { render, staticRenderFns } from "./AreaConcentracao.vue?vue&type=template&id=d3dd4762&scoped=true&"
import script from "./AreaConcentracao.vue?vue&type=script&lang=js&"
export * from "./AreaConcentracao.vue?vue&type=script&lang=js&"
import style0 from "./AreaConcentracao.vue?vue&type=style&index=0&id=d3dd4762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3dd4762",
  null
  
)

export default component.exports